import './_suggestedList.scss'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { Link } from 'react-router-dom'
import { useInView } from 'react-intersection-observer'

import { getCreators } from 'services/endpoints/creator'
import { type ICreator } from 'types/interfaces/ICreator'

import Creator from '../CreatorsList/Creator/Creator'

const SuggestedList = () => {
    const { t } = useTranslation()
    const { ref, inView } = useInView({
        triggerOnce: true,   // Only fire once
        threshold: 0.1       // Fire when 10% visible
    })
    const { data: creatorsData } = useQuery(
        ['shortSuggestedCreators'],
        async () =>
            await getCreators({
                page: 1,
                search: null
            }),
        {
            enabled: inView, // Only query when component is visible
            refetchOnWindowFocus: false,
            select(data) {
                return data?.data?.slice(0, 3)?.map((creator: any) => ({
                    ...creator,
                    userId: creator.id,
                    coverUrl: creator.cover,
                    avatarUrl: creator.avatar,
                    handle: creator.username
                }))
            }
        }
    )

    return (
        <div className='suggestedList' ref={ref}>
          <div className='suggestedList__top'>
            <div className='suggestedList__top--title'>
              {t('suggested')}
            </div>
{/*             <div className='suggestedList__top--link'>
              <Link to='/creators'>{t('seeMore')}</Link>
            </div> */}
          </div>
          {creatorsData?.map((creator: ICreator) => (
            <Creator
              key={creator.userId}
              creatorData={creator}
              renderLocation={'suggested'}
            />
          ))}
        </div>
      )
}

export default SuggestedList
